<template>
  <div id="app" class="app-container">
    <div v-if="isLoggedIn" class="header-wrapper">
      <Header/>
    </div>

    <main class="main-content">
      <router-view/>
    </main>
    
    <LoadingPopup :isLoading="loadingStore.isLoading" />
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import Header from '@/components/common/HeaderView.vue';
import LoadingPopup from "@/components/common/LoadingPopup.vue";
import { useLoadingStore } from '@/stores/loadingStore';

const route = useRoute()
const loadingStore = useLoadingStore();

const isLoggedIn = ref(!!localStorage.getItem('user_id'))

watch(() => route.path, () => {
  isLoggedIn.value = !!localStorage.getItem('user_id')
})

</script>

<style>
.app-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
  width: 100%;
}
</style>
